module.exports = __webpack_public_path__ + "static/media/t-shirts.2d89c2da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/t-shirts.jpg
// module id = 1191
// module chunks = 33